import { Modal } from 'antd'
import { type FunctionComponent } from 'react'
import Highlighter from 'react-highlight-words'
import styled from 'styled-components'
import { KolIntroTags } from '@/components/kol/kol-intro-tags'
import { useThemeConstants } from '@/hooks/use-theme-constants'
import { useIntl } from '@/i18n/hooks/use-intl'

interface KolIntroModalProps {
  visible: boolean
  toggleVisible: VoidFunction
  text: string
  customTags?: string | null
  highlightText?: string[]
}

export const KolIntroModal: FunctionComponent<KolIntroModalProps> = ({
  visible,
  toggleVisible,
  text,
  customTags,
  highlightText = [],
}) => {
  const { formatMessage } = useIntl()
  const { highlightStyle } = useThemeConstants()
  return (
    <Modal
      centered
      destroyOnClose
      footer={null}
      open={visible}
      width={520}
      onCancel={toggleVisible}
    >
      <ModalTitle>
        {formatMessage({ id: 'kol:section_kol_intro_title' })}
      </ModalTitle>
      <Intro>
        <Highlighter
          highlightClassName='highlight'
          highlightStyle={highlightStyle}
          searchWords={highlightText}
          textToHighlight={text}
        />
        {customTags && <KolIntroTags customTags={customTags} />}
      </Intro>
    </Modal>
  )
}

const ModalTitle = styled.div`
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: ${(props): string => props.theme.colors.base.grey.grey1};
  padding: 8px 8px 25px 8px;
`

const Intro = styled.div`
  padding: 8px 8px 25px 8px;
  word-break: normal;
  overflow-wrap: anywhere;
  white-space: pre-line;
  overflow-y: scroll;
  max-height: 500px;
`
